import type { Frame } from "../api/types";

export type FilterMode = "all" | "mine" | "linked" | "broken";

/** The Saved Frames list filter. Shared by the page and the export, which
 *  must agree on what "the list" is after a bulk capture refreshes it. */
export function applyFrameFilter(
  frames: Frame[], filter: FilterMode, myReviewerId: string,
): Frame[] {
  return frames.filter((f) => {
    if (filter === "mine") return f.capturedBy.reviewerId === myReviewerId;
    if (filter === "linked") return f.poiId !== undefined;
    if (filter === "broken") return f.hasThumb === false;
    return true;
  });
}
